import React, { FC } from 'react';
import ReactModal from 'react-modal';

import { Panel } from '@kapital-bank/kb-ui-design-system';

import CloseIcon from 'shared/assets/images/compressImage/close-soft-icon.svg';
import infoBB from 'shared/assets/images/compressImage/info-bb.svg';
import infoKB from 'shared/assets/images/compressImage/info-kb.svg';
import infoUM from 'shared/assets/images/compressImage/info-um.svg';
import { styleModal } from 'shared/assets/styles/react-modal';
import { useGeneralInfoContext } from 'shared/context/WithGeneralInfo/GeneralInfoContext';
import { ESalesChannel } from 'shared/enum';
import { ICrossSellData } from 'shared/model';

import './index.scss';

interface IProps {
  openInsuranceModal: boolean;
  handleCloseModal: () => void;
  insuranceModalData: ICrossSellData;
}
interface IModalContent {
  id: number;
  title: string;
  desc?: string | number | null;
}

const InsuranceModal: FC<IProps> = ({ openInsuranceModal, handleCloseModal, insuranceModalData }) => {
  const { channelType } = useGeneralInfoContext();
  const modalContentList: Array<IModalContent | false> = [
    { id: 0, title: 'Ümumi məlumat', desc: insuranceModalData?.generalInformation },
    { id: 1, title: 'Sığorta haqqı:', desc: insuranceModalData?.detail },
    insuranceModalData?.amount != null && { id: 2, title: 'Sığorta məbləği:', desc: insuranceModalData?.amount },
  ];

  const filteredModalContentList = modalContentList.filter((item): item is IModalContent => Boolean(item));

  return (
    <ReactModal
      style={styleModal}
      isOpen={openInsuranceModal}
      onRequestClose={handleCloseModal}
      shouldCloseOnOverlayClick={false}
      className="modal insurance-modal"
    >
      <>
        <Panel>
          <Panel className="modal__header" justifyContent={4} alignItems={2}>
            <p className="modal__header__title">{insuranceModalData?.title}</p>
            <img className="modal-close" onClick={handleCloseModal} src={CloseIcon} alt="close" role="none" />
          </Panel>
        </Panel>
        <Panel className="modal-line" />
        <Panel className="modal-common-context">
          <Panel className="insurance-modal__context">
            {filteredModalContentList?.map(({ id, title, desc }) => (
              <div key={id}>
                <Panel className="insurance-modal__context__title">{title}</Panel>
                <p className="insurance-modal__context__description">{desc}</p>
              </div>
            ))}

            <div className="insurance-modal__context__description" />
            <Panel className={`insurance-modal__context__warning dangerColor-${channelType}`}>
              <img src={channelType === ESalesChannel.BIRBANK_AZ ? infoBB : channelType === ESalesChannel.UMICO ? infoUM : infoKB} alt="info" />
              <Panel marginLeft={2}>{insuranceModalData?.note}</Panel>
            </Panel>
          </Panel>
        </Panel>
      </>
    </ReactModal>
  );
};

export default InsuranceModal;
